import { UPDATE_KEY } from "../types";

export const updateMailingKey = () => {
  return {
    type: UPDATE_KEY,
  };
};
